<div class="card card-preview text-center h-100">
  <div class="card-body">
    <h4 class="h4 pt-1">
      <span [innerText]="contact.type"></span>
    </h4>
    <div class="avatar">
      <img [src]="contact.image" alt="">
    </div>
    <div class="contact-info">
      <strong>
        <span [innerText]="contact.name"></span>
      </strong><br>
      <span>
        <span>
          <strong>Tel </strong>
          <span [innerText]="contact.phone"></span>
        </span>
      </span><br>
      <span>
        <a [href]="'mailto:'+contact.email">
          <span [innerText]="contact.email"></span>
        </a>
      </span><br>
    </div>
  </div>
</div>
